let timeLimited = [
  // {
  //   path: '/winterActive',
  //   name: 'winterActive',
  //   component: () => import('@/pages/timeLimitedPages/winterActive/index.vue'),
  //   meta: {
  //     title: '冬日恋歌'
  //   }
  // },
  // {
  //   path: '/christmasActive',
  //   name: 'christmasActive',
  //   component: () => import('@/pages/timeLimitedPages/christmasActive/index.vue'),
  //   meta: {
  //     title: '圣诞飘雪奇妙夜'
  //   }
  // },
  // {
  //   path: '/newYearsDay',
  //   name: 'newYearsDay',
  //   component: () => import('@/pages/timeLimitedPages/newYearsDay/index.vue'),
  //   meta: {
  //     title: '元旦充值满返'
  //   }
  // },
  // {
  //   path: '/springFestivalActive',
  //   name: 'springFestivalActive',
  //   component: () => import('@/pages/timeLimitedPages/springFestivalActive/index.vue'),
  //   meta: {
  //     title: '新年迎好运'
  //   }
  // },{
  //   path: '/lanternFestivalActive',
  //   name: 'lanternFestivalActive',
  //   component: () => import('@/pages/timeLimitedPages/lanternFestivalActive/index.vue'),
  //   meta: {
  //     title: '喜庆过元宵'
  //   }
  // },{
  //   path: '/valentinesDay',
  //   name: 'valentinesDay',
  //   component: () => import('@/pages/timeLimitedPages/valentinesDay/index.vue'),
  //   meta: {
  //     title: '相约甜蜜情人节'
  //   }
  // },{
  //   path: '/goddessFestival',
  //   name: 'goddessFestival',
  //   component: () => import('@/pages/timeLimitedPages/goddessFestival/index.vue'),
  //   meta: {
  //     title: '真爱女神节'
  //   }
  // },
]

export {
  timeLimited
}